import { Component, OnInit } from '@angular/core';

import { HISTORIC_ROUTES_CONSTANTS } from './config';

@Component({
  selector: 'app-history-credit',
  templateUrl: './history-credit.component.html',
  styleUrls: ['./history-credit.component.css'],
})
export class HistoryCreditComponent implements OnInit {
  public HISTORIC_ROUTES_CONSTANTS: typeof HISTORIC_ROUTES_CONSTANTS;

  constructor() {
    this.HISTORIC_ROUTES_CONSTANTS = HISTORIC_ROUTES_CONSTANTS;
  }

  ngOnInit() {}
}
